import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d4b311f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weather_button" }

import MapView from './MapView'
import SelectWeatherDialog from './SelectWeatherDialog'
import IconButton from '@/components/molecules/IconButton'
import { scrollToTop } from '@/js/utils/util'
import { Camera } from '@/@types/typescript-axios'
import { computed, onMounted, ref } from 'vue'

type PropsType = {
  cameraLatLon: number[]
  firstCamera?: Camera
  backMarker: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CameraListMap',
  props: {
    cameraLatLon: null,
    firstCamera: null,
    backMarker: { type: Boolean }
  },
  emits: ["backMarkerStateChange", "hideLocationCameraList", "setLocationCameraList"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'backMarkerStateChange'): void
  (e: 'hideLocationCameraList'): void
  (e: 'setLocationCameraList', value: number): void
}), expose: any, slots: any, attrs: any }) {



//    todo height resize 改善必要
let mapHeight = ref<number | null>(null)
let toggleWeatherDialogFlag = ref(false)
let selectDate = ref<Date | null>(null)
let selectTime = ref<string | null>(null)
let selectWeather = ref<string | null>(null)
let typeNumber = ref<number | null>(null)
let okState = ref(false)

const map = ref<HTMLElement>()



const locationCameraList = (locationCode: number) => {
  emit('setLocationCameraList', locationCode)
}

const mapHeightSize = () => {
  if (map.value) {
    mapHeight.value = window.innerHeight - map.value.getBoundingClientRect().top - 24
  }
}

const showWeatherDialog = () => {
  toggleWeatherDialogFlag.value = !toggleWeatherDialogFlag.value
}

const refreshWeatherLayer = (
  date: Date,
  time: string,
  weather: string | null,
  weatherTypeNumber: number
) => {
  selectDate.value = date
  selectTime.value = time
  selectWeather.value = weather
  typeNumber.value = weatherTypeNumber
  okState.value = true
}

const close = () => {
  okState.value = false
}

const backMarkerStateChange = () => {
  emit('backMarkerStateChange')
}

const hideLocationCameraList = () => {
  emit('hideLocationCameraList')
}

onMounted(() => {
  scrollToTop()
  mapHeightSize()
})

const baseViewStyle = computed<{ height: string }>(() => ({
  height: `${mapHeight.value}px`,
}))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "BaseView",
    style: _normalizeStyle(_unref(baseViewStyle)),
    ref_key: "map",
    ref: map
  }, [
    _createVNode(_unref(MapView), {
      ref: "mapView",
      onLocationCameraList: locationCameraList,
      onBackMarkerStateChange: backMarkerStateChange,
      onHideLocationCameraList: hideLocationCameraList,
      onShowWeatherDialog: showWeatherDialog,
      "camera-lat-lon": __props.cameraLatLon,
      "first-camera": __props.firstCamera,
      "weather-api-info": [
        _unref(selectDate),
        _unref(selectTime),
        _unref(selectWeather),
        _unref(typeNumber),
        _unref(okState),
        _unref(toggleWeatherDialogFlag),
      ],
      "back-marker": __props.backMarker
    }, null, 8, ["camera-lat-lon", "first-camera", "weather-api-info", "back-marker"]),
    _createVNode(_unref(SelectWeatherDialog), {
      modelValue: _unref(toggleWeatherDialogFlag),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(toggleWeatherDialogFlag) ? (toggleWeatherDialogFlag).value = $event : toggleWeatherDialogFlag = $event)),
      onChanged: refreshWeatherLayer,
      onClose: close
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(IconButton), {
        icon: "beach_access",
        "use-border": false,
        "icon-color": "color-dark2",
        "bg-color": "white",
        onClick: showWeatherDialog
      })
    ])
  ], 4))
}
}

})